export const APP_ROUTES = {
    ASK_GUARDIAN : `/ask_guardian`,
    DEVIATION_RADAR: "/deviation_radar",
    KPI_REPORTING: "/kpi_reporting",
}